import React, { useState } from 'react';
import bg from './bg.webp'
import './App.css';
import { ip } from './constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';
import { decryptAesEcbCp1251 } from './crypto-utils';
function LoginView() {
  const [login, setLogin] = useState("");
  const [password, setPass] = useState("");

  const handleClick = (e) => {
    var path = ip + '/api/user/login';

    var hash = 0;

    if (password.length == 0) return hash;

    for (var i = 0; i < password.length; i++) {
      var char = password.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }


    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'Content-type: application/json; charset=win1251' },
      encoding: 'latin1',
      credentials: 'include',
      body: JSON.stringify({
        "login": login,
        "pass": hash
      })
    };
    fetch(path, requestOptions)
      .then()
      .then(response => { return response.arrayBuffer() })
      .then((buffer) => {
        const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
        const text = decoder.decode(buffer);
        try {
       
        var k = ""
        var s = ""
        for (let i = 0; i < text.length; i++) {
          if (s.length % 3 == 0 && k.length < 44) {
            k += text[i++];
          }
          s += text[i];
        }



        const decryptedText = decryptAesEcbCp1251(s, k);
        
          var result = JSON.parse(decryptedText);
          const cookies = new Cookies();




          if (result.status_code == 200) {
            cookies.set('login', result.data.login, { path: '/', maxAge: 28800 });
            cookies.set('type', result.data.type, { path: '/', maxAge: 28800 });
            
            if (result.data.type == 1) {
              window.open("/main", "_self")
            } else if (result.type == 2) {
              window.open("/main", "_self")
            } else if (result.type == 3) {
              window.open("/main", "_self")
            } else if (result.type == 4) {
              window.open("/main", "_self")
            } else if (result.type == 22) {
              window.open("/telegram", "_self")
            }
          } else {
            Swal.fire({
              title: result.msg,
              //text: "Оновити інформацію?",
              icon: "error",
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ОК',
              denyButtonText: 'Оновити',

              background: '#2B2B2B',
              color: '#FFF'
            }).then((result) => {


            })
          }
        } catch (error) {
          var result = JSON.parse(text);

          Swal.fire({
            title: result.msg,
            //text: "Оновити інформацію?",
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'ОК',
            denyButtonText: 'Оновити',

            background: '#2B2B2B',
            color: '#FFF'
          }).then((result) => {

          })
        }



        e.preventDefault();
      })



      /*.then(body => {
        var iconv = require('iconv-lite');
        var b = new Buffer (body, 'binary');
        var result = JSON.parse(iconv.encode (iconv.decode (new Buffer (body, 'binary'), 'cp1251'), 'utf8'));
        if (result.status_code == 200) {
  
        } else {
          Swal.fire({
            title: result.msg,
            //text: "Оновити інформацію?",
            icon: 'warning',
            html:
            '',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'Створити',
            denyButtonText: 'Оновити',
  
            background: '#005460',
            color: '#FFF'
          }).then((result) => {
            
            
        })
      }
        //setCount(result);
        //var a = document.getElementById("countTitle");
        //a.innerHTML = "Кількість карток у базі - " + result
    
        e.preventDefault();
    })*/
      .catch(err =>
        console.error(err));
    e.preventDefault();
  };


  function requestDevice() {


  }

  return (
    <div className="App">
      <div className="container">
        <div className="image-side">
          <img src={bg} className="full-height-image" alt="background" />
        </div>
        <div className="text-side">
          <div className="input-panel">
            <div className="titleSpace">S P A C E</div>
            <form  >
              <input className="input-text" id="login" name="login" type="text" value={login} onChange={(e) => setLogin((e.target.value))} placeholder="Логін" />
              <br />
              <input className="input-text" name="pass" type="password" value={password} onChange={(e) => setPass((e.target.value))} placeholder="Пароль" />
              <br />
              <input className="input-button" value="Увійти" type="submit" onClick={handleClick} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginView;